import React, { useEffect } from 'react'
import primerPremio from '../../../../media/svg/primer-premio.svg'
import segundoPremio from '../../../../media/svg/segundo-premio.svg'
import tercerPremio from '../../../../media/svg/tercer-premio.svg'

import { useConcursoTikTok } from "../../../../hooks/useConcursoTikTok2025"

const PremiosView = () => {

    const { premios, getPremios } = useConcursoTikTok();

    useEffect(() => {
        getPremios(2026)
    }, [])

    return (
        <div className="container-fluid section-home" id="premios">
            <div className="row justify-content-center">
                <div className="col-12 anchor-section">
                </div>
                <div className="col-md-8 inner-sections">
                    <div className="title-tiktok-info">
                        <h2>Premios</h2>
                    </div>
                    <div className="container-inner-info p-4">
                        <div className="awards-section-grid">
                            {
                                premios.map((item, i) => {
                                    switch (i) {
                                        case 0:
                                            return <div className="inner-awards">
                                                <div className="img-award">
                                                    <img src={primerPremio} alt="Primer premio" />
                                                </div>
                                                <div className="container-info-awards">
                                                    <h3>{item.titulo}</h3>
                                                    <p>{item.descripcion}</p>
                                                </div>
                                            </div>
                                        case 1:
                                            return <div className="inner-awards">
                                                <div className="img-award">
                                                    <img src={segundoPremio} alt="Primer premio" />
                                                </div>
                                                <div className="container-info-awards">
                                                    <h3>{item.titulo}</h3>
                                                    <p>{item.descripcion}</p>
                                                </div>
                                            </div>
                                        case 2:
                                            return <div className="inner-awards">
                                                <div className="img-award">
                                                    <img src={tercerPremio} alt="Primer premio" />
                                                </div>
                                                <div className="container-info-awards">
                                                    <h3>{item.titulo}</h3>
                                                    <p>{item.descripcion}</p>
                                                </div>
                                            </div>
                                        default:
                                            return <div className="inner-awards">
                                                <div className="img-award">
                                                    <img src={primerPremio} alt="Primer premio" />
                                                </div>
                                                <div className="container-info-awards">
                                                    <h3>{item.titulo}</h3>
                                                    <p>{item.descripcion}</p>
                                                </div>
                                            </div>
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PremiosView
